webpackJsonp([256131847211823],{

/***/ 1584:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"TreatmentSheetTemplateInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"default","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"enabledLocationIds","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"isDisabled","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"rows","type":{"kind":"LIST","name":null,"ofType":{"kind":"INPUT_OBJECT","name":"TreatmentTemplateSection","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-treatment-sheet-template-input-483be935fad57cea4112.js